import { cn } from '@poseidon/components/cn';
import { Media } from '@poseidon/components/StrokeIcons';

interface Props {
  className?: string;
}

/**
 * A rep paused this contact's enrollment — said the same way on the List view (above the steps) and the Graph
 * view (over the canvas), with how to undo it.
 */
export function SequencePausedNotice({ className }: Props) {
  return (
    <div
      data-sequence-paused
      className={cn(
        'flex items-start gap-2 rounded-lg border border-yellow-300 bg-yellow-50 px-3 py-2 text-sm text-yellow-800 dark:border-yellow-700/60 dark:bg-yellow-950 dark:text-yellow-200',
        className,
      )}>
      <Media.PauseCircle className="mt-0.5 size-4 shrink-0" />
      <span>
        Paused for this contact — nothing sends and no wait counts down until it’s resumed. Resume from the sequence’s
        pill above.
      </span>
    </div>
  );
}
